// Shadcn-style sidebar primitives
export {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarGroup,
  SidebarGroupAction,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarHeader,
  SidebarInput,
  SidebarInset,
  SidebarMenu,
  SidebarMenuAction,
  SidebarMenuBadge,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarMenuSkeleton,
  SidebarMenuSub,
  SidebarMenuSubButton,
  SidebarMenuSubItem,
  SidebarProvider,
  SidebarRail,
  SidebarSeparator,
  SidebarTrigger,
  useSidebar,
} from './sidebar';

// GLP-styled sidebar
export {
  GLPSidebar,
  GLPSidebarProvider,
  GLPSidebarNavGroup,
  GLPSidebarItem,
  useGLPSidebar,
  type NavItem,
  type UserProfile,
} from './glp-sidebar';

// GLP-styled secondary (inner) sidebar
export {
  GLPSecondarySidebar,
  GLPSecondarySidebarProvider,
  useGLPSecondarySidebar,
  type GLPSecondaryNavItem,
} from './glp-secondary-sidebar';

// Mobile shell pieces (used by `responsive` GLPSidebar; exported for custom layouts)
export { GLPMobileTopBar, GLPMobileNavDrawer } from './glp-mobile-nav';
export {
  useMobileNavAutoClose,
  type UseMobileNavAutoCloseOptions,
} from './use-mobile-nav-auto-close';

// Data-driven nav tree (modules + section links) and its active-path matching
export {
  buildNavItems,
  buildSecondaryNavItems,
  findActiveNavModule,
  findActiveNavSection,
  isNavPathActive,
  type NavMatch,
  type NavTreeLink,
  type NavTreeModule,
} from './nav-tree';

// User profile widget for the GLP sidebar
export {
  GLPUserProfile,
  type GLPUserProfileUser,
  type GLPUserProfileMenuItem,
  type GLPUserProfileMenuSection,
  type GLPUserProfileProps,
} from './glp-user-profile';
